import axios from "axios";
import { PortalAccessResponse } from "redmond";
import { portalAccessPrefixV1 } from "../../paths";

const ENDPOINT = `${portalAccessPrefixV1}/businessAuthorized`;

const fetchBusinessPortalAuthorized =
  async (): Promise<PortalAccessResponse> => {
    const resp = await axios.put(
      ENDPOINT,
      {},
      {
        withCredentials: true,
      }
    );

    const data = resp.data as Partial<PortalAccessResponse>;

    if (
      typeof data?.isAuthorized !== "boolean" ||
      !Array.isArray(data?.rewardsAccounts) ||
      !Array.isArray(data?.businesses)
    ) {
      throw new Error("Unexpected businessAuthorized response");
    }

    return data as PortalAccessResponse;
  };

export default fetchBusinessPortalAuthorized;
